import React, { Component } from "react";
import store from "store";
import ReactPlayer from "react-player";
import YouTube from "react-youtube";
import { Link } from "react-router-dom";

import { FormatDateIndo, BASE_URL } from "../../Util";
import { trans } from "../../Lang";
import CourseConstants from "../Constants";

class CourseContentResources extends Component {
  render() {
    const { data, topicList, activeTopic, thumbnail, onMediaAction } =
      this.props;
    const resourceType = activeTopic.resource_type;
    const url = activeTopic.resource_url;

    if (!activeTopic || activeTopic.locked) {
      return (
        <div className="center">
          <img src={thumbnail} className="course-thumbnail" />
        </div>
      );
    } else {
      switch (resourceType) {
        case CourseConstants.TYPE_VIDEO:
          if (
            url !== null &&
            (url.includes("youtube.com") || url.includes("youtu.be"))
          ) {
            const videoURL = url
              .replace(/(>|<)/gi, "")
              .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            const videoID = videoURL[2] !== undefined ? videoURL[2] : url[2];
            const options = {
              height: "390",
              width: "800",
              playerVars: {
                autoplay: 0,
              },
            };
            return (
              <YouTube
                id="YTVideo"
                videoId={videoID}
                containerClassName="yt-video-wrapper"
                opts={options}
                onPlay={() => onMediaAction(activeTopic, 1)}
                onPause={() => onMediaAction(activeTopic, 2)}
                onEnd={() => onMediaAction(activeTopic, 3)}
                onError={() => onMediaAction(activeTopic, 4)}
              />
            );
          } else {
            return (
              <ReactPlayer
                style={{ background: "black" }}
                preload="none"
                id="video"
                poster={thumbnail}
                ref="video"
                width="100%"
                url={url}
                controls={true}
                onEnded={() => onMediaAction(topicList, 3)}
                onError={() => onMediaAction(topicList, 4)}
                onPause={() => onMediaAction(topicList, 2)}
                onPlay={() => onMediaAction(topicList, 1)}
              />
            );
          }
        case CourseConstants.TYPE_AUDIO: {
          return (
            <ReactPlayer
              style={{ background: `url(${thumbnail})` }}
              preload="none"
              id="audio"
              poster={thumbnail}
              ref="audio"
              width="100%"
              url={url}
              controls={true}
              onEnded={() => onMediaAction(topicList, 3)}
              onError={() => onMediaAction(topicList, 4)}
              onPause={() => onMediaAction(topicList, 2)}
              onPlay={() => onMediaAction(topicList, 1)}
            />
          );
        }
        case CourseConstants.TYPE_PDF: {
          return (
            <div class="container-iframe">
              <iframe
                onLoad={() => {
                  onMediaAction(topicList, 3);
                }}
                className="pdf"
                /* src={`https://docs.google.com/gview?url=${url}&embedded=true`} */
                src={url}
                frameBorder="0"
              ></iframe>
            </div>
          );
        }
        case CourseConstants.TYPE_QUIZ: {
          const quizData = store.get(`quiz_${activeTopic.uuid}`);
          const lastAttempt = activeTopic.last_accessed;
          const completed = activeTopic.completed;

          let retakeQuizBtn = "";
          let quizText = `Uji pemahaman Anda secara jujur. Selamat mengerjakan!!`;
          let quizResultBtn = (
            <Link
              to={`/quiz/result/${activeTopic.uuid}`}
              className="btn full-s capitalize"
            >
              Lihat Hasil
            </Link>
          );

          if (quizData) {
            quizText =
              "Jawaban Anda sebelumnya belum dikirim. Silakan klik button di bawah untuk melanjutkan sesi sebelumnya";
            retakeQuizBtn = (
              <Link
                to={`/quiz/${activeTopic.uuid}`}
                className="btn full-s capitalize"
              >
                Lanjut
              </Link>
            );
            quizResultBtn = "";
          } else if (lastAttempt) {
            quizText = `Anda telah menyelesaikan materi ini pada tanggal "${FormatDateIndo(
              lastAttempt
            )}". Lihat kembali hasilnya dengan menekan tombol berikut.`;
            retakeQuizBtn = (
              <Link
                to={`/quiz/${activeTopic.uuid}`}
                className="btn full-s capitalize btn-outline"
              >
                Ulang Kuis
              </Link>
            );
            if (completed) {
              let lastModule = data.modules[data.modules.length - 1];
              let lastTopic = lastModule.topics[lastModule.topics.length - 1];
              if (
                (lastTopic && lastTopic.uuid != activeTopic.uuid) ||
                data.completed
              )
                retakeQuizBtn = "";
            } else {
              quizText +=
                " Jika Anda belum lulus, Anda dapat mengulangi kuis ini sampai Anda lulus";
            }
          } else {
            retakeQuizBtn = (
              <Link
                to={`/quiz/${activeTopic.uuid}`}
                className="btn full-s capitalize"
              >
                Mulai
              </Link>
            );
            quizResultBtn = "";
          }

          return (
            <div className="pad-m pad-l center">
              <h4>{activeTopic.title}</h4>
              <h5>{activeTopic.module_title}</h5>
              <div className="pad-l">
                <img src={BASE_URL + "/img/quiz-reminder.png"} />
              </div>
              <p className="h5 font-light mb-m">{quizText}</p>
              {retakeQuizBtn} &nbsp; {quizResultBtn}
            </div>
          );
        }
        default:
          return (
            <div className="center">
              <img src={thumbnail} />
            </div>
          );
      }
    }
  }
}

export default CourseContentResources;



// WEBPACK FOOTER //
// ./src/components/Course/components/CourseContentResources.js